import styles from "./style.module.scss";
import FrameIcon from "assets/icons/frameIcon";
import classNames from "classnames";

const VideoIndicationIcon = ({ small }: { small?: boolean }) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.small]: small,
      })}
    >
      <FrameIcon />
    </div>
  );
};

export default VideoIndicationIcon;
